import React from 'react';
import Image from 'components/Models/Image/Image'
import PropTypes from 'prop-types';

const ImageIcon = ({
    className,
    url,
    altText
}) => (
    <img className={className} src={url} alt={altText} />
);

ImageIcon.propTypes = Object.assign({}, Image.propTypes, {
    className: PropTypes.string
});

export default ImageIcon;



// WEBPACK FOOTER //
// ./src/components/ImageIcon/ImageIcon.jsx